export const VENUE_CALENDAR_WEBSOCKET_EVENTS = [
  "RESERVATION_CREATED",
  "RESERVATION_DELETED",
  "RECURRING_RESERVATION_CREATED",
  "RECURRING_RESERVATION_DELETED",
  "RECURRING_RESERVATION_RENEWED",
  "RESERVATION_UPDATED"
] as const;

export const ACTIVITY_LOG_WEBSOCKET_EVENTS = [
  "RESERVATION_CREATED",
  "RESERVATION_DELETED",
  "RECURRING_RESERVATION_CREATED",
  "RECURRING_RESERVATION_DELETED",
  "RECURRING_RESERVATION_RENEWED",
  "RESERVATION_UPDATED"
] as const;
